type Options = {
  keys: unknown[];
  variables?: Record<string, any>;
  subscriptionId?: string;
  orderId?: string;
  token?: string;
};

export function getQueryKeyForUpscribe({
  keys,
  variables,
  subscriptionId,
  orderId,
  token
}: Options) {
  return [
    'upscribe',
    ...keys,
    {
      ...variables,
      subscriptionId,
      orderId,
      token
    }
  ];
}
